var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4310_88229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1638 6.5625C8.82785 6.5625 6.55276 9.21569 5.57715 10.6594C6.34213 11.7783 8.62277 14.7656 11.1638 14.7656C13.4998 14.7656 15.7749 12.1124 16.7505 10.669C15.9855 9.5498 13.7049 6.5625 11.1638 6.5625ZM11.1638 13.125C9.80688 13.125 8.70288 12.021 8.70288 10.6641C8.70288 9.30712 9.80688 8.20312 11.1638 8.20312C12.5207 8.20312 13.6247 9.30712 13.6247 10.6641C13.6247 12.021 12.5207 13.125 11.1638 13.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2551 18.2755C21.9317 17.9503 21.3846 17.952 21.0655 18.3066L20.5449 18.8851L19.2535 17.5938C20.8542 15.7278 21.8281 13.3096 21.8281 10.6643C21.8281 4.78432 17.044 0.000244141 11.164 0.000244141C5.28408 0.000244141 0.5 4.78432 0.5 10.6643C0.5 16.5443 5.28408 21.3283 11.164 21.3283C13.8093 21.3283 16.2275 20.3544 18.0935 18.7538L19.4458 20.106L18.8673 20.7484C18.5757 21.0728 18.5885 21.5687 18.897 21.8771L24.3003 27.2788C25.2619 28.2403 26.8179 28.2412 27.7803 27.2788C28.7399 26.319 28.7399 24.7585 27.7803 23.7989L22.2551 18.2755ZM18.4306 11.0849C18.301 11.302 15.2071 16.4065 11.164 16.4065C7.12102 16.4065 4.02712 11.302 3.89746 11.0849C3.74279 10.8262 3.74279 10.5026 3.89746 10.2437C4.02712 10.0266 7.12102 4.92211 11.164 4.92211C15.2071 4.92211 18.301 10.0266 18.4306 10.2437C18.5853 10.5026 18.5853 10.8262 18.4306 11.0849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1641 9.84375C10.7114 9.84375 10.3438 10.2114 10.3438 10.6641C10.3438 11.1167 10.7114 11.4844 11.1641 11.4844C11.6167 11.4844 11.9844 11.1167 11.9844 10.6641C11.9844 10.2114 11.6167 9.84375 11.1641 9.84375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4310_88229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewIcon);
export default __webpack_public_path__ + "static/media/review-icon.24ec304d84c2d5f7be8c408ed8b668f4.svg";
export { ForwardRef as ReactComponent };